import { ChatMockApi } from '@mock-api/apps/chat/api';
import { HelpCenterMockApi } from '@mock-api/apps/help-center/api';
import { MessagesMockApi } from '@mock-api/common/messages/api';
import { NavigationMockApi } from '@mock-api/common/navigation/api';
import { NotificationsMockApi } from '@mock-api/common/notifications/api';
import { SearchMockApi } from '@mock-api/common/search/api';
import { ShortcutsMockApi } from '@mock-api/common/shortcuts/api';
import { UserMockApi } from '@mock-api/common/user/api';

export const mockApiServices = [
    ChatMockApi,
    HelpCenterMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotificationsMockApi,
    SearchMockApi,
    ShortcutsMockApi,
    UserMockApi
];
